import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Result } from '@softline/core';
import { SOFTLINE_API_ANWENDER_LAGER } from '../lager-core.api';
import { AnwenderLager } from '../types/anwender-lager';

@Injectable()
export class UserWarehouseRepository {
  dataAccess = inject(ApiDataAccess);

  constructor() {}

  async getUserWarehouse(): Promise<AnwenderLager[]> {
    return (
      await this.dataAccess.get<Result<AnwenderLager[]>>({
        path: SOFTLINE_API_ANWENDER_LAGER,
      })
    )?.result;
  }
}
